import { createReducer } from "typesafe-actions";
import * as act from "../actions/LayoutActions"


type State = {
    showError: boolean,
    errorMessage: string
}

const initialState: State = {
    showError: false,
    errorMessage: ''
}


const layoutReducer = createReducer(initialState)
    .handleAction(act.showError, (state, action) => { return { ...state, showError: true, errorMessage: action.payload } })
    .handleAction(act.hideError, (state) => { return { ...state, showError: false, errorMessage: '' } })

export default layoutReducer
